import axiosInstance from "./AxiosInstance";

const BASE_URL = "/api/v3/usuarios/citofonos/";
const IMPORT_URL = "/api/v3/usuarios/inmuebles/importar/";
const EXPORT_URL = "/api/v3/usuarios/citofonos/exportar/";
const SEND_PASSWORD_URL = "/api/v3/usuarios/citofonos/send_password/";

export const CitofonoService = {
  listarUnidades: (params = {}) => axiosInstance.get(BASE_URL, { params }),

  obtenerUnidad: (slug) => axiosInstance.get(`${BASE_URL}${slug}/`),

  crearUnidad: (data) => axiosInstance.post(BASE_URL, data),

  editarUnidad: (slug, data) => axiosInstance.patch(`${BASE_URL}${slug}/`, data),

  eliminarUnidad: (slug) => axiosInstance.delete(`${BASE_URL}${slug}/`),

  importarUnidades: (file) => {
    const formData = new FormData();
    formData.append("file_import", file);

    return axiosInstance.post(IMPORT_URL, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  exportarUnidades: () =>
    axiosInstance({
      url: EXPORT_URL,
      method: "GET",
      responseType: "blob",
    }),

  enviarPasswords: () => axiosInstance.get(SEND_PASSWORD_URL),

  enviarAccesoConsejo: (slug) =>
    axiosInstance.get(`${BASE_URL}${slug}/send-acceso-consejo/`),
};

export default CitofonoService;
